{
  "version": "1.0",
  "builder": "dashboard",
  "stepperOrientation": "horizontal",
  "linear": false,
  "steps": [
    {
      "id": "setup",
      "label": "Setup",
      "sections": [
        { "id": "setup", "fields": [{ "field": "setup" }] }
      ]
    },
    {
      "id": "components",
      "label": "Components",
      "sections": [
        { "id": "components", "fields": [{ "field": "components" }] }
      ]
    },
    {
      "id": "filters",
      "label": "Filters",
      "sections": [
        { "id": "filters", "fields": [{ "field": "filters" }] }
      ]
    },
    {
      "id": "arrange",
      "label": "Arrange",
      "sections": [
        { "id": "arrange", "fields": [{ "field": "arrange" }] }
      ]
    }
  ],

  "options": {
    "columnOptions": [1, 2, 3, 4],
    "columnSpanOptions": [
      { "value": "1", "label": "1 col" },
      { "value": "2", "label": "2 cols" },
      { "value": "3", "label": "3 cols" },
      { "value": "4", "label": "Full width" }
    ],
    "globalFiltersPositions": [
      { "value": "top", "label": "Top" },
      { "value": "left", "label": "Left" },
      { "value": "right", "label": "Right" }
    ]
  },

  "defaults": {
    "columns": 3,
    "dashboardName": "Untitled dashboard"
  },

  "apiEndpoints": {
    "baseUrl": "",
    "uploadUrl": "",
    "chatUrl": "/ppt-dashboard/generate",
    "savedDashboard":""
  }
}
